
const application_shop_index = () => import(/* webpackChunkName: "ehcarts" */ '../application/shop/index');
const application_shop_shop_add = () => import(/* webpackChunkName: "ehcarts" */ '../application/shop/shop_add');
const data_index = () => import(/* webpackChunkName: "ehcarts" */ '../data/index.vue');
const member_login = () => import(/* webpackChunkName: "member_login" */ '../login/index');
const member_register = () => import(/* webpackChunkName: "member_login" */ '../login/register');
const member_otherLogin = () => import(/* webpackChunkName: "member_login" */ '../login/otherLogin');
const member_password = () => import(/* webpackChunkName: "member_login" */ '../login/password');
const editback = () => import(/* webpackChunkName: "editback" */ '../edit/workEditor');
const editback_roam = () => import(/* webpackChunkName: "editback_roam" */ '../edit_roam/workEditor');
const video_replace = () => import(/* webpackChunkName: "editback_roam" */ '../material/phoneReplace.vue');
//工具相关
const video_make = () => import(/* webpackChunkName: "member_tools" */ '../tool/video_make.vue');
const aihuman_make = () => import(/* webpackChunkName: "member_tools" */ '../tool/aihuman_make.vue');
const imagehuman_make = () => import(/* webpackChunkName: "member_tools" */ '../tool/imagehuman_make.vue');
const audioClone = () => import(/* webpackChunkName: "member_tools" */ '../tool/audioClone.vue');
const talk_make = () => import(/* webpackChunkName: "member_tools" */ '../tool/talk_make.vue');
const audioSynthesis = () => import(/* webpackChunkName: "member_tools" */ '../tool/audioSynthesis.vue');
const video_addmusic = () => import(/* webpackChunkName: "member_tools" */ '../tool/video_addmusic.vue');
const poster_make = () => import(/* webpackChunkName: "member_tools" */ '../tool/poster_make.vue');
const ai_draw = () => import(/* webpackChunkName: "member_tools" */ '../tool/ai_draw.vue');
const ai_voice = () => import(/* webpackChunkName: "member_tools" */ '../tool/ai_voice.vue');

var member_router = [

    {
        path: '/member/help/index', //常见问题
        name: '/member/help/index',
        component: resolve => require(['../help/index'], resolve),
        meta: {
            title: "帮助中心"
        },
    },
    {
        path: '/member/help/problem', //常见问题
        name: '/member/help/problem',
        component: resolve => require(['../help/problem'], resolve),
        meta: {
            title: "帮助中心"
        },
    },
    {
        path: '/member/webstyle/style1', //个性官网-模板一
        name: '/member/webstyle/style1',
        component: resolve => require(['../webstyle/style1'], resolve),
        meta: {
            title: "个性官网"
        },
    },
    {
        path: '/member/webstyle/style2', //个性官网-模板二
        name: '/member/webstyle/style2',
        component: resolve => require(['../webstyle/style2'], resolve),
        meta: {
            title: "个性官网"
        },
    },
    {
        path: '/member/login', //登录页
        name: '/member/login',
        component: member_login,
        meta: {
            title: "终端登录"
        },
    },
    {
        path: '/member/videoReplace',
        name:'/member/videoReplace',
        component:video_replace,
        meta:{
            title:'抖音发布'
        }
    },
    {
        path: '/member/login/index', //登录页
        name: '/member/login/index',
        component: member_login,
        meta: {
            title: "终端登录"
        },
    },
    {
        path: '/member/login/index/co/:type?', //登录页
        name: '/member/login/index/co',
        component: member_login,
        meta: {
            title: "终端登录"
        },
    },
    {
        path: '/member/register', //注册页
        name: '/member/register',
        component: member_register,
        redirect: {
            path: '/member/login',
            query: {current: "2"}
        },
        meta: {
            title: "终端注册"
        },
    },
    {
        path: '/member/otherLogin', //第三方登录页
        name: '/member/otherLogin',
        component: member_otherLogin,
        meta: {
            title: "第三方登录"
        },
    },
    {
        path: '/member/password', //忘记密码
        name: '/member/password',
        component: member_password,
        meta: {
            title: "忘记密码"
        },
    },
    {
        path: '/member',
        name: '/member', //作品列表
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/work',
        children: [{
            path: '/member/work', //全景图片
            name: '/member/work',
            component: resolve => require(['../work/index'], resolve),
            meta: {
                title: "全景图片",
                navtitle:'作品管理'
            },
        },
            {
                path: '/member/work/video', //全景视频
                name: '/member/work/video',
                component: resolve => require(['../work/video'], resolve),
                meta: {
                    title: "全景视频",
                    navtitle:'作品管理'
                },
            },
	      {
	        path: '/member/work/threeRoaming', //3D漫游
	        name: '/member/work/threeRoaming',
	        component: (resolve) => require(['../work/threeRoaming'], resolve),
	        meta: {
	          title: '3D漫游',
              navtitle:'作品管理'
	        }
	      },
	      {
	        path: '/member/work/yun', //VR云游
	        name: '/member/work/yun',
	        component: (resolve) => require(['../yun/index.vue'], resolve),
	        meta: {
	          title: 'VR云游',
              navtitle:'作品管理'
	        }
	      },
	      {
	        path: '/member/work/recycled', //回收站
	        name: '/member/work/recycled',
	        component: (resolve) => require(['../recycled/index.vue'], resolve),
	        meta: {
	          title: '回收站',
              navtitle:'作品管理'
	        }
	      },
	      {
	        path: '/member/work/maproam', //酷客导航
	        name: '/member/work/maproam',
	        component: (resolve) => require(['../maproam/index.vue'], resolve),
	        meta: {
	          title: '酷客导航',
              navtitle:'作品管理'
	        }
	      }
        ]
    },
    {
        path: '/member/work/edit', //编辑后台
        name: '/member/work/edit',
        component: editback,
        meta: {
            title: "编辑后台"
        },
    },
    {
        path: '/member/work/edit_roam', //编辑后台
        name: '/member/work/edit_roam',
        component: editback_roam,
        meta: {
            title: "编辑后台"
        },
    },
    {
        path: '/member/material_body',
        name: '/member/material_body', //作品列表
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/material',
        children: [{
                path: '/member/material', //图片
                name: '/member/material',
                component: resolve => require(['../material/index'], resolve),
                meta: {
                    title: "图片",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/pano_photo', //全景图片
                name: '/member/material/pano_photo',
                component: resolve => require(['../material/pano_photo'], resolve),
                meta: {
                    title: "全景图片",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/threeRoaming', //3D漫游
                name: '/member/material/threeRoaming',
                component: (resolve) => require(['../material/threeRoaming'], resolve),
                meta: {
                  title: '3D漫游',
                  navtitle:'资料管理'
                }
            },
            {
                path: '/member/material/pano_video', //全景视频
                name: '/member/material/pano_video',
                component: resolve => require(['../material/pano_video'], resolve),
                meta: {
                    title: "全景视频",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/video', //视频
                name: '/member/material/video',
                component: resolve => require(['../material/video'], resolve),
                meta: {
                    title: "视频",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/music', //音频
                name: '/member/material/music',
                component: resolve => require(['../material/music'], resolve),
                meta: {
                    title: "音频",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/album', //手册
                name: '/member/material/album',
                component: resolve => require(['../material/album'], resolve),
                meta: {
                    title: "手册",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/instruction', //场景说明
                name: '/member/material/instruction',
                component: resolve => require(['../material/instruction'], resolve),
                meta: {
                    title: "场景说明",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/link', //链接
                name: '/member/material/link',
                component: resolve => require(['../material/link'], resolve),
                meta: {
                    title: "链接",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/surround', //360物体
                name: '/member/material/surround',
                component: resolve => require(['../material/surround'], resolve),
                meta: {
                    title: "360物体",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/news', //图文
                name: '/member/material/news',
                component: resolve => require(['../material/news'], resolve),
                meta: {
                    title: "图文",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/three', //模型
                name: '/member/material/three',
                component: resolve => require(['../material/three'], resolve),
                meta: {
                    title: "模型",
                    navtitle:'资料管理'
                },
            },
            {
                path: '/member/material/doc2pdf', //文档
                name: '/member/material/doc2pdf',
                component: resolve => require(['../material/doc2pdf'], resolve),
                meta: {
                    title: "文档",
                    navtitle:'资料管理'
                },
            },
        ]
    },
    {
        path: '/member/data',
        name: '/member/data', //数据信息
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/data/index',
        children: [{
            path: '/member/data/index', //访问数据
            name: '/member/data/index',
            component: data_index,
            meta: {
                title: "数据概况",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/pcoffline', //离线数据包
            name: '/member/data/pcoffline',
            component: resolve => require(['../data/pcoffline.vue'], resolve),
            meta: {
                title: "全景数据包",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/pcofflineRecord', //离线数据包购买记录
            name: '/member/data/pcofflineRecord',
            component: resolve => require(['../data/pcofflineRecord.vue'], resolve),
            meta: {
                title: "离线数据包购买记录",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/pcofflineLog', //离线数据包购买记录
            name: '/member/data/pcofflineLog',
            component: resolve => require(['../data/pcofflineLog.vue'], resolve),
            meta: {
                title: "离线数据包购买记录",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/pcofflineExplain', //离线数据包说明
            name: '/member/data/pcofflineExplain',
            component: resolve => require(['../data/pcofflineExplain.vue'], resolve),
            meta: {
                title: "离线数据包说明",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/say', //离线数据包说明
            name: '/member/data/say',
            component: resolve => require(['../data/say.vue'], resolve),
            meta: {
                title: "说说管理",
                navtitle:'数据中心'
            },

        },  {
            path: '/member/data/interactManage', //全景直播
            name: '/member/data/interactManage',
            component: resolve => require(['../data/interactManage.vue'], resolve),
            meta: {
                title: "全景直播",
                navtitle:'数据中心'
            },
        },
        {
            path: '/member/data/maproam_say', //酷客导航
            name: '/member/data/maproam_say',
            component: resolve => require(['../data/maproam_say.vue'], resolve),
            meta: {
                title: "酷客导航点评",
                navtitle:'数据中心'
            },
        },{
            path: '/member/data/message', //留言管理
            name: '/member/data/message',
            component: resolve => require(['../data/message.vue'], resolve),
            meta: {
                title: "留言管理",
                navtitle:'数据中心'
            },
        },

         //     path: '/member/live_child/interactManage', //互动内容管理
            //     name: '/member/live_child/interactManage',
            //     component: resolve => require(['../live/interactManage.vue'], resolve),
        {
            path: '/member/data/order_box', //订单中心-电商系统
            name: '/member/data/order_box',
            component: resolve => require(['../data/order_box.vue'], resolve),
            meta: {
                title: "订单中心",
                navtitle:'数据中心'
            },
        },
        {
            path: '/member/data/student', //数据中心-学生管理
            name: '/member/data/student',
            component: resolve => require(['../data/student.vue'], resolve),
            meta: {
                title: "学生管理",
                navtitle:'数据中心'
            },
        },
        {
            path: '/member/data/order', //订单中心-电商系统
            name: '/member/data/order',
            component: resolve => require(['../data/order.vue'], resolve),
            meta: {
                title: "电商系统",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/restaurant', //订单中心-VR餐饮系统
            name: '/member/data/restaurant',
            component: resolve => require(['../data/restaurant.vue'], resolve),
            meta: {
                title: "VR餐饮系统",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/seckill', //订单中心-商品秒杀
            name: '/member/data/seckill',
            component: resolve => require(['../data/seckill.vue'], resolve),
            meta: {
                title: "商品秒杀",
                navtitle:'数据中心'
            },
        }, {
            path: '/member/data/system', //订单中心-预约系统
            name: '/member/data/system',
            component: resolve => require(['../data/system.vue'], resolve),
            meta: {
                title: "预约系统",
                navtitle:'数据中心'
            },
        },
        {
            path: '/member/data/panoramicLive', //全景直播
            name: '/member/data/panoramicLive',
            component: resolve => require(['../data/panoramicLive.vue'], resolve),
            meta: {
                title: "直播数据",
                navtitle:'数据中心'
            },
        },
        {
            path: '/member/data/vrmeeting', //全景直播
            name: '/member/data/vrmeeting',
            component: resolve => require(['../data/vrmeeting.vue'], resolve),
            meta: {
                title: "VR带看",
                navtitle:'数据中心'
            },
        }]
    },
    {
        path: '/member/mybooth',
        name: '/member/mybooth', //我要展位
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/mybooth/index',
        children: [{
            path: '/member/mybooth/index', //全景图片
            name: '/member/mybooth/index',
            component: resolve => require(['../mybooth/index.vue'], resolve),
            meta: {
                title: "我要展位",
                navtitle:'我要展位'
            },
        },]
    },
    // {
    //     path: '/member/maproam',
    //     name: '/member/maproam', //酷客导航
    //     component: resolve => require(['../layout/main'], resolve),
    //     redirect: '/member/maproam/index',
    //     children: [{
    //         path: '/member/maproam/index', //全景图片
    //         name: '/member/maproam/index',
    //         component: resolve => require(['../maproam/index.vue'], resolve),
    //         meta: {
    //             title: "酷客导航",
    //             navtitle:'作品管理'
    //         },
    //     },]
    // },
    {
        path: '/member/wxadoc',
        name: '/member/wxadoc', //小程序
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/wxadoc/index',
        children: [{
            path: '/member/wxadoc/index',
            name: '/member/wxadoc/index',
            component: resolve => require(['../wxadoc/index.vue'], resolve),
            meta: {
                title: "小程序",
                navtitle:'小程序'
            },
        },]
    },
    {
        path: '/member/generate',
        name: '/member/generate', //小程序
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/generate/index',
        children: [{
            path: '/member/generate/index',
            name: '/member/generate/index',
            component: resolve => require(['../generate/index.vue'], resolve),
            meta: {
                title: "AI创作工具",
                navtitle:'AI创作工具'
            },
        },]
    },
    {
        path: '/member/solution',
        name: '/member/solution', //小程序
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/solution/index',
        children: [{
            path: '/member/solution/index',
            name: '/member/solution/index',
            component: resolve => require(['../solution/index.vue'], resolve),
            meta: {
                title: "解决方案",
                navtitle:'解决方案',
                isshownav:'0'
            },
        },]
    },
    {
        path: '/member/domain',
        name: '/member/domain', //域名设置
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/domain/index',
        children: [{
            path: '/member/domain/index',
            name: '/member/domain/index',
            component: resolve => require(['../domain/index.vue'], resolve),
            meta: {
                title: "域名设置",
                navtitle:'域名设置',
                isshownav:'0'
            },
        },]
    },
    {
        path: '/member/web',
        name: '/member/web', //个性官网
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/web/set',
        children: [{
            path: '/member/web/set', //基本设置
            name: '/member/web/set',
            component: resolve => require(['../web/set.vue'], resolve),
            meta: {
                title: "基本设置",
                navtitle:'个性官网'
            },
        },
            {
                path: '/member/web/mould', //官网模板
                name: '/member/web/mould',
                component: resolve => require(['../web/mould.vue'], resolve),
                meta: {
                    title: "网站模板",
                    navtitle:'个性官网'
                },
            },
            {
                path: '/member/web/imgtext', //产品
                name: '/member/web/imgtext',
                component: resolve => require(['../web/imgtext.vue'], resolve),
                meta: {
                    title: "产品",
                    navtitle:'个性官网'
                },
            },
            {
                path: '/member/web/news', //图文
                name: '/member/web/news',
                component: resolve => require(['../web/news.vue'], resolve),
                meta: {
                    title: "图文",
                    navtitle:'个性官网'
                },
            },
            {
                path: '/member/web/imglist', //列表
                name: '/member/web/imglist',
                component: resolve => require(['../web/imglist.vue'], resolve),
                meta: {
                    title: "列表",
                    navtitle:'个性官网'
                },
            },
            {
                path: '/member/web/messages', //留言管理
                name: '/member/web/messages',
                component: resolve => require(['../web/messages.vue'], resolve),
                meta: {
                    title: "留言管理",
                    navtitle:'个性官网'
                },
            },
        ]
    },
    {
        path: '/member/live',
        name: '/member/live', //直播
        component: resolve => require(['../layout/main'], resolve),
        redirect: '/member/live/index',
        children: [{
            path: '/member/live/index', //房间列表
            name: '/member/live/index',
            component: resolve => require(['../live/index.vue'], resolve),
            meta: {
                title: "房间列表",
                navtitle:'全景直播'
            },
        },
        {
            path: '/member/live/index/livelist', //直播列表
            name: '/member/live/livelist',
            component: resolve => require(['../live/livelist.vue'], resolve),
            meta: {
                title: "直播管理",
                navtitle:'全景直播'
            },
        },
        {
            path: '/member/live/index/set', //基础设置
            name: '/member/live/set',
            component: resolve => require(['../live/set.vue'], resolve),
            meta: {
                title: "基础设置",
                navtitle:'全景直播'
            },
        },
        {
            path: '/member/live/index/advert', //广告设置
            name: '/member/live/advert',
            component: resolve => require(['../live/advert.vue'], resolve),
            meta: {
                title: "其他设置",
                navtitle:'全景直播'
            },
        },
        {
            path: '/member/live/index/address', //观看地址
            name: '/member/live/address',
            component: resolve => require(['../live/address.vue'], resolve),
            meta: {
                title: "观看地址",
                navtitle:'全景直播'
            },
        },

        {
            path: '/member/live/wares', //商品设置
            name: '/member/live/wares',
            component: resolve => require(['../live/wares.vue'], resolve),
            meta: {
                title: "商品设置",
                navtitle:'全景直播'
            },
        },
        {
            path: '/member/live/index/liveListWares', //商品设置
            name: '/member/live/liveListWares',
            component: resolve => require(['../live/liveListWares.vue'], resolve),
            meta: {
                title: "商品推送",
                navtitle:'全景直播'
            },
        },
        {
            path: '/member/live/manage', //管理员列表
            name: '/member/live/manage',
            component: resolve => require(['../live/manage.vue'], resolve),
            meta: {
                title: "管理员列表",
                navtitle:'全景直播'
            },
        }],
    },
    {
        path: '/member/live/bindmanager', //绑定管理员
        name: '/member/live/bindmanager',
        component: resolve => require(['../live/bindmanager.vue'], resolve),
        meta: {
            title: "绑定管理员",
            navtitle:'全景直播'
        },
    },
    {
        path: '/member/live/link', //直播界面
        name: '/member/live/link',
        component: resolve => require(['../live/live_link.vue'], resolve),
        meta: {
            title: "在线直播",
            navtitle:'全景直播'
        },
    },
    // {
    //     path: '/member/live_child',
    //     name: '/member/live_child', //直播
    //     component: resolve => require(['../layout/main'], resolve),
    //     redirect: '/member/live_child/livelist',
    //     children: [{
    //         path: '/member/live_child/livelist', //直播列表
    //         name: '/member/live_child/livelist',
    //         component: resolve => require(['../live/livelist.vue'], resolve),
    //         meta: {
    //             title: "直播列表",
    //             navtitle:'全景直播'
    //         },
    //     }, {
    //         path: '/member/live_child/set', //基础设置
    //         name: '/member/live_child/set',
    //         component: resolve => require(['../live/set.vue'], resolve),
    //         meta: {
    //             title: "基础设置",
    //             navtitle:'全景直播'
    //         },
    //     }, {
    //         path: '/member/live_child/page', //页面设置
    //         name: '/member/live_child/page',
    //         component: resolve => require(['../live/page.vue'], resolve),
    //         meta: {
    //             title: "页面设置",
    //             navtitle:'全景直播'
    //         },
    //     }, {
    //         path: '/member/live_child/advert', //广告设置
    //         name: '/member/live_child/advert',
    //         component: resolve => require(['../live/advert.vue'], resolve),
    //         meta: {
    //             title: "其他设置",
    //             navtitle:'全景直播'
    //         },
    //     }, {
    //         path: '/member/live_child/wares', //商品设置
    //         name: '/member/live_child/wares',
    //         component: resolve => require(['../live/wares.vue'], resolve),
    //         meta: {
    //             title: "商品设置",
    //             navtitle:'全景直播'
    //         },
    //     }, {
    //         path: '/member/live_child/address', //观看地址
    //         name: '/member/live_child/address',
    //         component: resolve => require(['../live/address.vue'], resolve),
    //         meta: {
    //             title: "观看地址",
    //             navtitle:'全景直播'
    //         },
    //     }, {
    //         path: '/member/live_child/interactManage', //互动内容管理
    //         name: '/member/live_child/interactManage',
    //         component: resolve => require(['../live/interactManage.vue'], resolve),
    //         meta: {
    //             title: "互动内容管理",
    //             navtitle:'全景直播'
    //         },
    //     }],
    // },
    {
        path: '/member/pushflow',
        name: '/member/pushflow', //推流地址
        component: resolve => require(['../live/pushflow'], resolve),
        meta: {
            title: "推流地址",
            navtitle:'全景直播'
        },
    },
    {
        path: '/member/maproamEditor',
        name: '/member/maproamEditor', //作品列表
        component: resolve => require(['../maproam/maproamEditor'], resolve),
        meta: {
            title: "规划线路",
            navtitle:'全景直播'
        },
    },
    {
        path: '/member/user_body',
        name: '/member/user_body', //个人资料
        component: resolve => require(['../layout/main'], resolve),
        children: [{
            path: '/member/user', //个人资料
            name: '/member/user',
            component: resolve => require(['../user/personal'], resolve),
            meta: {
                title: "个人资料",
                navtitle:'个人中心'
            },
        }, {
            path: '/member/user/password', //修改密码
            name: '/member/user/password',
            component: resolve => require(['../user/password'], resolve),
            meta: {
                title: "修改密码",
                navtitle:'个人中心'
            },
        },]
    },
    {
        path: '/member/setting_body',
        name: '/member/setting_body', //域名设置
        component: resolve => require(['../layout/main'], resolve),
        children: [{
            path: '/member/setting/pay', //支付设置
            name: '/member/setting/pay',
            component: resolve => require(['../setting/pay'], resolve),
            meta: {
                title: "微信",
                navtitle:'三方接入'
            },
        }, {
            path: '/member/setting/zfbPay', //支付设置
            name: '/member/setting/zfbPay',
            component: resolve => require(['../setting/zfbPay'], resolve),
            meta: {
                title: "支付宝",
                navtitle:'三方接入'
            },
                }, {
            path: '/member/setting/fcprinter', //打印机设置
            name: '/member/setting/fcprinter',
            component: resolve => require(['../setting/fcprinter'], resolve),
            meta: {
                title: "打印机设置",
                navtitle:'系统设置'
            },
        }, {
            path: '/member/setting/vrshow', //第三方接入
            name: '/member/setting/vrshow',
            component: resolve => require(['../setting/vrshow'], resolve),
            meta: {
                title: "口碑VR秀",
                navtitle:'三方接入'
            },
        }, {
            path: '/member/setting/pico', //Pico列表
            name: '/member/setting/pico',
            component: resolve => require(['../setting/pico'], resolve),
            meta: {
                title: "Pico头显",
                navtitle:'三方接入'
            },
        }, {
            path: '/member/setting/quick', //快手
            name: '/member/setting/quick',
            component: resolve => require(['../setting/quick'], resolve),
            meta: {
                title: "快手小程序",
                navtitle:'三方接入'
            },
        },
        {
            path: '/member/setting/tiktok', //快手
            name: '/member/setting/tiktok',
            component: resolve => require(['../setting/tiktok'], resolve),
            meta: {
                title: "抖音小程序",
                navtitle:'三方接入'
            },
        },
        {
            path: '/member/setting/succes', //快手
            name: '/member/setting/succes',
            component: resolve => require(['../setting/succes'], resolve),
            meta: {
                title: "成功",
                navtitle:'三方接入'
            },
        },
        {
            path: '/member/setting/koubei', //口碑
            name: '/member/setting/koubei',
            component: resolve => require(['../setting/koubei'], resolve),
            meta: {
                title: "口碑详情页广告",
                navtitle:'三方接入'
            },
        }, {
            path: '/member/setting/applets', //小程序
            name: '/member/setting/applets',
            component: resolve => require(['../setting/applets'], resolve),
            meta: {
                title: "公众号/小程序设置说明",
                navtitle:'三方接入'
            },
        }, {
            path: '/member/setting/wxamp', //公众号
            name: '/member/setting/wxamp',
            component: resolve => require(['../setting/wxamp'], resolve),
            meta: {
                title: "公众号",
                navtitle:'三方接入'
            },
        },
        ]
    },
    {
        path: '/member/new',
        name: '/member/new', //消息中心
        component: resolve => require(['../layout/main'], resolve),
        children: [{
            path: '/member/new/index',
            name: '/member/new/index',
            component: resolve => require(['../new/index'], resolve),
            meta: {
                title: "消息中心",
                navtitle:'消息中心'
            },
        },
            {
                path: '/member/new/week',
                name: '/member/new/week',
                component: resolve => require(['../new/week'], resolve),
                meta: {
                    title: "系统更新",
                    navtitle:'消息中心'
                },
            }
        ]
    },
    {
        path: '/member/marketCenter',
        name: '/member/marketCenter', // 营销中心-活动
        component: resolve => require(['../layout/main'], resolve),
        children: [{
            path: '/member/marketCenter/index', // 测试页
            name: '/member/marketCenter/index',
            component: resolve => require(['../marketCenter/index'], resolve),
        }, {
            path: '/member/marketCenter/whack_a_mole', // 打地鼠
            name: '/member/marketCenter/whack_a_mole',
            component: resolve => require(['../marketCenter/whack_a_mole'], resolve),
            meta: {
                title: "打地鼠",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/card_voucher', // 卡券投放
            name: '/member/marketCenter/card_voucher',
            component: resolve => require(['../marketCenter/card_voucher'], resolve),
            meta: {
                title: "卡券投放",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/red_envelopes', // 红包投放
            name: '/member/marketCenter/red_envelopes',
            component: resolve => require(['../marketCenter/red_envelopes'], resolve),
            meta: {
                title: "红包投放",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/smash_golden_eggs', // 砸金蛋
            name: '/member/marketCenter/smash_golden_eggs',
            component: resolve => require(['../marketCenter/smash_golden_eggs'], resolve),
            meta: {
                title: "砸金蛋",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/jigsaw', //拼图
            name: '/member/marketCenter/jigsaw',
            component: resolve => require(['../marketCenter/jigsaw'], resolve),
            meta: {title: "旋转拼图",
            navtitle:'营销中心'},
        }, {
            path: '/member/marketCenter/jigsaw/awardsList', //拼图
            name: '/member/marketCenter/components/list/v_jigsaw_awardsList',
            component: resolve => require(['../marketCenter/components/list/v_jigsaw_awardsList'], resolve),
            meta: {title: "获奖记录",
            navtitle:'营销中心'},
        }, {
            path: '/member/marketCenter/jigsaw/add', //拼图-添加活动
            name: '/member/marketCenter/components/v_jigsaw_add',
            component: resolve => require(['../marketCenter/components/v_jigsaw_add'], resolve),
            meta: {
                title: "添加活动",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/panorama_treasure', // 全景宝藏
            name: '/member/marketCenter/panorama_treasure',
            component: resolve => require(['../marketCenter/panorama_treasure'], resolve),
            meta: {
                title: "全景宝藏",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/collect_card', // 集卡活动
            name: '/member/marketCenter/collect_card',
            component: resolve => require(['../marketCenter/collect_card'], resolve),
            meta: {
                title: "集卡活动",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/lucky_turntable', // 幸运大转盘
            name: '/member/marketCenter/lucky_turntable',
            component: resolve => require(['../marketCenter/lucky_turntable'], resolve),
            meta: {
                title: "幸运大转盘",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/scraping_card', // 刮刮卡
            name: '/member/marketCenter/scraping_card',
            component: resolve => require(['../marketCenter/scraping_card'], resolve),
            meta: {
                title: "刮刮卡",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/still_standing', // 一站到底
            name: '/member/marketCenter/still_standing',
            component: resolve => require(['../marketCenter/still_standing'], resolve),
            meta: {
                title: "一站到底",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/still_standing2', // 知识答人
            name: '/member/marketCenter/still_standing2',
            component: resolve => require(['../marketCenter/still_standing2'], resolve),
            meta: {
                title: "知识答人",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/collect_word', // 集字游戏
            name: '/member/marketCenter/collect_word',
            component: resolve => require(['../marketCenter/collect_word'], resolve),
            meta: {
                title: "集字游戏",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/nine_squares', // 九宫格
            name: '/member/marketCenter/nine_squares',
            component: resolve => require(['../marketCenter/nine_squares'], resolve),
            meta: {
                title: "九宫格",
                navtitle:'营销中心'
            },
        }, {
            path: '/member/marketCenter/vote', // 投票
            name: '/member/marketCenter/vote',
            component: resolve => require(['../marketCenter/vote'], resolve),
            meta: {
                title: "投票",
                navtitle:'营销中心'
            },
        },


            // 营销中心-活动  子页面
            {
                path: '/member/marketCenter/whack_a_mole/add', //打地鼠-添加活动
                name: '/member/marketCenter/components/v_dds_add',
                component: resolve => require(['../marketCenter/components/v_dds_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/whack_a_mole/awardsList', //打地鼠-浏览
                name: '/member/marketCenter/components/list/v_dds_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_dds_awardsList'], resolve),
                meta: {
                    title: "浏览",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/card_voucher/add', //卡券投放-添加活动
                name: '/member/marketCenter/components/v_kq_add',
                component: resolve => require(['../marketCenter/components/v_kq_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/card_voucher/writeOffList', //卡券投放-核销记录
                name: '/member/marketCenter/components/list/v_kq_writeOffList',
                component: resolve => require(['../marketCenter/components/list/v_kq_writeOffList'], resolve),
                meta: {
                    title: "核销记录",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/red_envelopes/add', //红包-添加活动
                name: '/member/marketCenter/components/v_hb_add',
                component: resolve => require(['../marketCenter/components/v_hb_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/red_envelopes/awardsList', //红包-获奖名单
                name: '/member/marketCenter/components/list/v_hb_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_hb_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/red_envelopes/shareRecordList', //红包-分享记录
                name: '/member/marketCenter/components/list/v_hb_shareRecordList',
                component: resolve => require(['../marketCenter/components/list/v_hb_shareRecordList'], resolve),
                meta: {
                    title: "分享记录",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/smash_golden_eggs/add', //砸金蛋-添加活动
                name: '/member/marketCenter/components/v_zjd_add',
                component: resolve => require(['../marketCenter/components/v_zjd_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/smash_golden_eggs/awardsList', //砸金蛋-获奖名单
                name: '/member/marketCenter/components/list/v_zjd_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_zjd_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/panorama_treasure/add', //全景宝藏-添加活动
                name: '/member/marketCenter/components/v_qjbz_add',
                component: resolve => require(['../marketCenter/components/v_qjbz_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/panorama_treasure/awardsList', //全景宝藏-获奖名单
                name: '/member/marketCenter/components/list/v_qjbz_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_qjbz_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/panorama_treasure/launch', //全景宝藏-投放记录
                name: '/member/marketCenter/components/list/v_qjbz_Launch',
                component: resolve => require(['../marketCenter/components/list/v_qjbz_Launch'], resolve),
                meta: {
                    title: "投放记录",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/collect_card/add', //集卡活动-添加活动
                name: '/member/marketCenter/components/v_jk_add',
                component: resolve => require(['../marketCenter/components/v_jk_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/collect_card/awardsList', //集卡活动-获奖名单
                name: '/member/marketCenter/components/list/v_jk_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_jk_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/lucky_turntable/add', //幸运大转盘-添加活动
                name: '/member/marketCenter/components/v_dzp_add',
                component: resolve => require(['../marketCenter/components/v_dzp_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/lucky_turntable/awardsList', //幸运大转盘-获奖名单
                name: '/member/marketCenter/components/list/v_dzp_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_dzp_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/scraping_card/add', //刮刮卡-添加活动
                name: '/member/marketCenter/components/v_ggk_add',
                component: resolve => require(['../marketCenter/components/v_ggk_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/scraping_card/awardsList', //刮刮卡-获奖名单
                name: '/member/marketCenter/components/list/v_ggk_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_ggk_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/collect_word/add', //集字游戏-添加活动
                name: '/member/marketCenter/components/v_jz_add',
                component: resolve => require(['../marketCenter/components/v_jz_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/collect_word/awardsList', //集字游戏-获奖名单
                name: '/member/marketCenter/components/list/v_jz_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_jz_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/nine_squares/add', //九宫格-添加活动
                name: '/member/marketCenter/components/v_jgg_add',
                component: resolve => require(['../marketCenter/components/v_jgg_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/nine_squares/awardsList', //九宫格-获奖名单
                name: '/member/marketCenter/components/list/v_jgg_awardsList',
                component: resolve => require(['../marketCenter/components/list/v_jgg_awardsList'], resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/vote/addAct', //投票-添加活动
                name: '/member/marketCenter/components/v_tp_addAct',
                component: resolve => require(['../marketCenter/components/v_tp_addAct'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/vote/addGift', //投票-添加礼物
                name: '/member/marketCenter/components/v_tp_addGift',
                component: resolve => require(['../marketCenter/components/v_tp_addGift'], resolve),
                meta: {
                    title: "添加礼物",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/vote/addVoteUser', //投票-添加投票用户
                name: '/member/marketCenter/components/v_tp_addVoteUser',
                component: resolve => require(['../marketCenter/components/v_tp_addVoteUser'], resolve),
                meta: {
                    title: "添加投票用户",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/vote/voteManage', //投票-投票管理
                name: '/member/marketCenter/components/list/v_tp_voteManage',
                component: resolve => require(['../marketCenter/components/list/v_tp_voteManage'], resolve),
                meta: {
                    title: "投票管理",
                    navtitle:'营销中心'
                },
            },

            {
                path: '/member/marketCenter/still_standing/add', //一站到底-添加活动
                name: '/member/marketCenter/components/standSub/v_yzdd_add',
                component: resolve => require(['../marketCenter/components/standSub/v_yzdd_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/still_standing/awardsList', //一站到底-获奖名单
                name: '/member/marketCenter/components/standSub/v_yzdd_awardsList',
                component: resolve => require(['../marketCenter/components/standSub/v_yzdd_awardsList'],
                    resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/still_standing/addQuestion', //一站到底-题目管理
                name: '/member/marketCenter/components/standSub/v_yzdd_addQuestion',
                component: resolve => require(['../marketCenter/components/standSub/v_yzdd_addQuestion'],
                    resolve),
                meta: {
                    title: "题目管理",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/still_standing/activityQuestion', //一站到底-题库管理
                name: '/member/marketCenter/components/standSub/v_yzdd_activityQuestion',
                component: resolve => require(['../marketCenter/components/standSub/v_yzdd_activityQuestion'],
                    resolve),
                meta: {
                    title: "题库管理",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/still_standing2/add', //知识答人-添加活动 定制
                name: '/member/marketCenter/components/standSub2/v_yzdd_add',
                component: resolve => require(['../marketCenter/components/standSub2/v_yzdd_add'], resolve),
                meta: {
                    title: "添加活动",
                    navtitle:'营销中心'
                },
            },{
                path: '/member/marketCenter/still_standing2/awardsList', //知识答人-答题记录
                name: '/member/marketCenter/components/standSub2/v_yzdd_awardsList',
                component: resolve => require(['../marketCenter/components/standSub2/v_yzdd_awardsList'],
                    resolve),
                meta: {
                    title: "获奖名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/still_standing2/addQuestion', //知识答人-添加题目
                name: '/member/marketCenter/components/standSub2/v_yzdd_addQuestion',
                component: resolve => require(['../marketCenter/components/standSub2/v_yzdd_addQuestion'],
                    resolve),
                meta: {
                    title: "题目管理",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/still_standing2/activityQuestion', //知识答人-题库管理
                name: '/member/marketCenter/components/standSub2/v_yzdd_activityQuestion',
                component: resolve => require(['../marketCenter/components/standSub2/v_yzdd_activityQuestion'],
                    resolve),
                meta: {
                    title: "题库管理",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/marketCenter/activity_push', //推送列表
                name: '/member/marketCenter/activity_push',
                component: resolve => require(['../marketCenter/activity_push'],
                    resolve),
                meta: {
                    title: "推送",
                    navtitle:'营销中心'
                },
            },
            //新增返佣
            {
                path: '/member/marketCenter/feedback_money', //推送列表
                name: '/member/marketCenter/feedback_money',
                component: resolve => require(['../marketCenter/feedback_money'],
                    resolve),
                meta: {
                    title: "返佣",
                    navtitle:'营销中心'
                },
            },


            //应用

            {
                path: '/member/application/shop', // 电商
                name: '/member/application/shop',
                component: application_shop_index,
                meta: {
                    title: "电商系统",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/shop/shop_add', // 添加商品
                name: '/member/application/shop/shop_add',
                component: application_shop_shop_add,
                meta: {
                    title: "商品管理",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/booking_body', // 预约系统
                name: '/member/application/booking_body',
                component: resolve => require(['../application/booking/index'], resolve),
                children: [{
                    path: '/member/application/booking',
                    name: '/member/application/booking',
                    component: resolve => require(['../application/booking/booking'], resolve),
                    meta: {
                        title: "预约系统",
                        navtitle:'营销中心'
                    },
                },]
            },
            {
                path: '/member/application/booking/add', // 添加预约
                name: '/member/application/booking/add',
                component: resolve => require(['../application/booking/add'], resolve),
                meta: {
                    title: "添加预约",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/booking/booklist', // 套餐管理
                name: '/member/application/booking/booklist',
                component: resolve => require(['../application/booking/booklist'], resolve),
                meta: {
                    title: "套餐管理",
                    navtitle:'营销中心'
                },
            },

            {
                path: '/member/application/booking/bookorderlist', // 预约订单
                name: '/member/application/booking/bookorderlist',
                component: resolve => require(['../application/booking/bookorderlist'], resolve),
                meta: {
                    title: "预约订单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/booking/bookadds', // 编辑套餐
                name: '/member/application/booking/bookadds',
                component: resolve => require(['../application/booking/bookadd'], resolve),
                meta: {
                    title: "编辑套餐",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/invite_body', // 线上邀请函
                name: '/member/application/invite_body',
                component: resolve => require(['../application/invite/index'], resolve),
                children: [{
                    path: '/member/application/invite',
                    name: '/member/application/invite',
                    component: resolve => require(['../application/invite/invite'], resolve),
                    meta: {
                        title: "线上邀请函",
                        navtitle:'营销中心'
                    },
                },]
            },
            {
                path: '/member/application/invite/enroll', //查看报名记录
                name: '/member/application/invite/enroll',
                component: resolve => require(['../application/invite/enroll'], resolve),
                meta: {
                    title: "查看报名记录",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/invite/add', //添加邀请函
                name: '/member/application/invite/add',
                component: resolve => require(['../application/invite/add'], resolve),
                meta: {
                    title: "添加邀请函",
                    navtitle:'营销中心'
                },
            },

            {
                path: '/member/application/seckill', // 商品秒杀
                name: '/member/application/seckill',
                component: resolve => require(['../application/seckill/index'], resolve),
                meta: {
                    title: "商品秒杀",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/seckill/action_add', // 添加秒杀
                name: '/member/application/seckill/action_add',
                component: resolve => require(['../application/seckill/action_add'], resolve),
                meta: {
                    title: "添加秒杀",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/seckill/shop_detail', // 查看商品
                name: '/member/application/seckill/shop_detail',
                component: resolve => require(['../application/seckill/shop_detail'], resolve),
                meta: {
                    title: "查看商品",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/seckill/order_man', // 查看订单列表
                name: '/member/application/seckill/order_man',
                component: resolve => require(['../application/seckill/order_man'], resolve),
                meta: {
                    title: "查看订单列表",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/seckill/order_detail', // 订单详情
                name: '/member/application/seckill/order_detail',
                component: resolve => require(['../application/seckill/order_detail'], resolve),
                meta: {
                    title: "订单详情",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/restaurant', // 餐饮系统
                name: '/member/application/restaurant',
                component: resolve => require(['../application/restaurant/index'], resolve),
                meta: {
                    title: "餐饮系统",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application_body', // 婚庆喜帖
                name: '/member/application_body',
                component: resolve => require(['../application/wedding/index'], resolve),
                children: [{
                    path: '/member/application/wedding', // 婚庆喜帖
                    name: '/member/application/wedding',
                    component: resolve => require(['../application/wedding/wedding'], resolve),
                    meta: {
                        title: "婚庆系统",
                        navtitle:'营销中心'
                    },
                }]
            },
            {
                path: '/member/application/wedding/add', // add婚庆喜帖
                name: '/member/application/wedding/add',
                component: resolve => require(['../application/wedding/add'], resolve),
                meta: {
                    title: "添加婚庆喜帖",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/wedding/weddingList', // 赴宴名单
                name: '/member/application/wedding/weddingList',
                component: resolve => require(['../application/wedding/weddingList'], resolve),
                meta: {
                    title: "赴宴名单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/seckill/add_goods', // 添加商品
                name: '/member/application/seckill/add_goods',
                component: resolve => require(['../application/seckill/add_goods'], resolve),
                meta: {
                    title: "添加商品",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/indent', // 添加商品
                name: '/member/application/indent',
                component: resolve => require(['../application/indent/index'], resolve),
                meta: {
                    title: "订购",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/indent/add', // 添加商品
                name: '/member/application/indent/add',
                component: resolve => require(['../application/indent/add'], resolve),
                meta: {
                    title: "添加订单",
                    navtitle:'营销中心'
                },
            },
            {
                path: '/member/application/indent/data', // 添加商品
                name: '/member/application/indent/data',
                component: resolve => require(['../application/indent/data'], resolve),
                meta: {
                    title: "订单列表",
                    navtitle:'营销中心'
                },
            },

        ]
    },
    {
        path: '/member/marketCenter/launch/index', // 投放红包、奖品、卡券
        name: '/member/marketCenter/launch/index',
        component: resolve => require(['../marketCenter/launch/index'], resolve),
        meta: {
            title: "投放"
        },
    },

    {
        path: '/member/yun/edit', // VR云游后台编辑
        name: '/member/yun/edit',
        component: resolve => require(['../yun/edit.vue'], resolve),
        meta: {
            title: "VR云游编辑"
        },
    },

    {
        path: '/member/tool',
        name: '/member/tool', //一键成片
        component: resolve => require(['../layout/main'], resolve),
        children: [
            {
                path: '/member/tool/video_make',
                name: '/member/tool/video_make',
                component: video_make,
                meta: {
                    title: "一键成片",
                    navtitle:'一键成片'
                },
            },
            {
                path: '/member/tool/aihuman_make',
                name: '/member/tool/aihuman_make',
                component: aihuman_make,
                meta: {
                    title: "AI数字人",
                    navtitle:'AI数字人'
                },
            },
            {
                path: '/member/tool/imagehuman_make',
                name: '/member/tool/imagehuman_make',
                component: imagehuman_make,
                meta: {
                    title: "图片数字人",
                    navtitle:'图片数字人'
                },
            },
            {
                path: '/member/tool/audioClone',
                name: '/member/tool/audioClone',
                component: audioClone,
                meta: {
                    title: "声音克隆",
                    navtitle:'声音克隆'
                },
            },
            {
                path: '/member/tool/talk_make',
                name: '/member/tool/talk_make',
                component: talk_make,
                meta: {
                    title: "重构视频原声",
                    navtitle:'重构视频原声'
                },

            },
            {
                path: '/member/tool/audioSynthesis',
                name: '/member/tool/audioSynthesis',
                component: audioSynthesis,
                meta: {
                    title: "语音合成",
                    navtitle:'语音合成',
                },
            },
            {
                path: '/member/tool/video_addmusic',
                name: '/member/tool/video_addmusic',
                component: video_addmusic,
                meta: {
                    title: "视频+背景音乐",
                    navtitle:'视频+背景音乐',
                },
            },
            {
                path: '/member/tool/poster_make',
                name: '/member/tool/poster_make',
                component: poster_make,
                meta: {
                    title: "创意海报",
                    navtitle:'创意海报',
                },
            },
            {
                path: '/member/tool/ai_draw',
                name: '/member/tool/ai_draw',
                component: ai_draw,
                meta: {
                    title: "文生图",
                    navtitle:'文生图',
                },
            },
            {
                path: '/member/tool/ai_voice',
                name: '/member/tool/ai_voice',
                component: ai_voice,
                meta: {
                    title: "声音合成",
                    navtitle:'声音合成',
                },
            },
        ]
    },
];

export {
    member_router
}



// WEBPACK FOOTER //
// ./src/member/router/index.js